import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './DialogHeader.styled';

/**
 * `DialogHeader` displays the top portion of overlaying components (like Modal/Drawer), which has support for showing left/right/bottom components in relation to the title.
 */
const DialogHeader = ({
  title,
  leftComponent,
  rightComponent,
  bottomComponent,
  withDivider,
  withCollapse,
  ...props
}) => {
  const titleToRender =
    title && typeof title === 'string' ? (
      <Styled.Title>{title}</Styled.Title>
    ) : (
      title
    );

  return (
    <Styled.DialogHeader
      withDivider={withDivider}
      withCollapse={withCollapse}
      {...props}
    >
      {leftComponent && (
        <Styled.FixedComponent side="left">
          {leftComponent}
        </Styled.FixedComponent>
      )}
      {title && (
        <>
          {titleToRender}
          {bottomComponent && (
            <Styled.BottomComponent>{bottomComponent}</Styled.BottomComponent>
          )}
        </>
      )}
      {rightComponent && (
        <Styled.FixedComponent side="right">
          {rightComponent}
        </Styled.FixedComponent>
      )}
    </Styled.DialogHeader>
  );
};

DialogHeader.propTypes = {
  /**
   * Title to display
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Component to display anchored to top left of header
   */
  leftComponent: PropTypes.node,
  /**
   * Component to display anchored to top right of header
   */
  rightComponent: PropTypes.node,
  /**
   * Component to display centered below the title
   */
  bottomComponent: PropTypes.node,
  /**
   * Adds bottom border/divider to Header
   */
  withDivider: PropTypes.bool,
  /**
   * Adds a min-height to modal's Dialog Header
   */
  withCollapse: PropTypes.bool
};

DialogHeader.defaultProps = {
  title: null,
  leftComponent: null,
  rightComponent: null,
  bottomComponent: null,
  withDivider: true,
  withCollapse: false
};

export default DialogHeader;
